module.exports = __webpack_public_path__ + "img/b4120472e3eb35898a93e1721de6f81f.jpg";